import { useQueryClient } from '@tanstack/react-query';

import useMutation from '../../../ReactQuery/useMutation';
import { post } from '../../../redux/api';
import { AVAILABLE_SERVICE_ACCOUNTS_QUERY_KEY } from '../oidc/useAvailableServiceAccounts';
import type {
  CreateServiceAccountRequest,
  CreateServiceAccountResponse,
} from '../../../../shared/types/routes/serviceAccounts';

/**
 * Creates a service account for the given organization.
 */
function createServiceAccount(data: CreateServiceAccountRequest) {
  return post<CreateServiceAccountRequest, CreateServiceAccountResponse>('/api/users/service-accounts', data);
}

/**
 * Hook to create a service account.
 */
export default function useCreateServiceAccount() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createServiceAccount,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [AVAILABLE_SERVICE_ACCOUNTS_QUERY_KEY] });
    },
  });
}
